module.exports = __webpack_public_path__ + "static/media/lucastswick-avatar.248b9703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/lucastswick-avatar.jpg
// module id = 4378
// module chunks = 15